export default {
  meta: {
    title: '部门管理'
  }
};
